import { useEffect } from 'react';
import { IconChartHistogram } from '@tabler/icons-react';

import { useScreen } from 'Screen/ScreenContext';

import useInsights from './hooks/useInsights';
import InsightsView from './view';

export default function Insights() {
    document.title = 'Insights | Ginastee';

    const { setBreadcrumb } = useScreen();
    const insights = useInsights();

    useEffect(() => {
        setBreadcrumb([
            { label: 'Insights', href: '/insights', icon: <IconChartHistogram size={18} /> },
            { label: 'Relatório de vendas' },
        ]);
        return () => setBreadcrumb(null);
    }, [setBreadcrumb]);

    return <InsightsView {...insights} />;
}
